import Contact from "../component/Contact";

function ContactPage(props) {
  return (
    <div>
      <Contact />
    </div>
  );
}

export default ContactPage;
